import {IOrderDTO} from "@/interface";
import {useNewOrderStore} from "@/stores/newOrder"

export interface IOrderPendingDTO extends IOrderDTO {
    numberPendingOptionsAdd: number,
    numberPendingOptionsCancel: number,
    optionName: string
}

export class PendingOptions {
    public optionName?: string | null;
    public numberPendingOptionsAdd: number;
    public numberPendingOptionsCancel: number;
    public scheduledDate: Date;

    constructor(base?: Partial<PendingOptions>){
        if(base) {
            Object.assign(this, base);
        }
    }

    public static fromDto(dto: IOrderDTO[]) {
        const newOrderStore = useNewOrderStore();

        const excludeProductPending: IOrderPendingDTO[] = dto.filter(pending => pending.order_id !== newOrderStore.orderPendingId) as IOrderPendingDTO[];

        excludeProductPending.map(element => {
            element.optionName = element.new_value || element.old_value || '';
            element.numberPendingOptionsCancel = element.new_value === null && element.old_value ? 1 : 0;
            element.numberPendingOptionsAdd = element.new_value && (element.old_value || element.old_value === null) ? 1 : 0;
        })

        return excludeProductPending.reduce((acc: { [key: string]: PendingOptions }, obj) => {
            const optionName = obj.optionName;
            if (!acc[optionName]) {
                acc[optionName] = {
                    numberPendingOptionsCancel: 0,
                    numberPendingOptionsAdd: 0,
                    scheduledDate: new Date()
                };
            }
            acc[optionName].numberPendingOptionsCancel += obj.numberPendingOptionsCancel;
            acc[optionName].numberPendingOptionsAdd += obj.numberPendingOptionsAdd;
            acc[optionName].scheduledDate = new Date(obj.scheduled_date);
            return acc;
        }, {});
    }
}